// @flow

import type { Result } from '../../../types'

export function prepareResult (
  poll: any
): Result {
  let votes = 0
  const items = poll.alternatives.list.map(id => {
    votes += poll.alternatives[id].votes
    return { id, ...poll.alternatives[id] }
  })
  return {
    alternatives: poll.alternatives,
    items,
    votes
  }
}



// WEBPACK FOOTER //
// ./src/shared/widgets/LivePoll/helpers/prepareResult.js